import { lazy } from "react";

const PartnerDetail = lazy(() => import("../pages/partner/detail/PartnerDetail"));
const PartnerDetailPreview = lazy(() => import("../pages/partner/detail/PartnerDetailPreview"));
const PartnerDetailInfoComponentExample = lazy(
  () => import("../pages/partner/detail/ExampleInfoComponent"),
);
const PartnerSelectBranch = lazy(() => import("../pages/partner/PartnerSelectBranch"));
const BlindReviews = lazy(() => import("../pages/partner/BlindReviews"));

const PartnerPhotoMain = lazy(() => import("../pages/partner/PartnerPhotoMain"));
const PartnerList = lazy(() => import("../pages/partner/PartnerList"));

export const partnerRoutes = [
  // 비즈에서 사용하는 예시 이미지 페이지
  { path: "/partner/info-component-example", element: <PartnerDetailInfoComponentExample /> },

  // 파트너 리스트
  { path: "/partner-list/:partnerType", element: <PartnerList /> },

  // 업체 상세 페이지
  { path: "/partner/:uuid", element: <PartnerDetail /> },
  { path: "/partner/:uuid/photo", element: <PartnerPhotoMain /> },
  { path: "/partner/:uuid/blind-reviews", element: <BlindReviews /> },

  // 업체 상세 - 미리보기, 비교하기
  { path: "/partner/:uuid/preview", element: <PartnerDetailPreview /> },

  // 업체 상세 - 지점 선택(예약) *
  { path: "/partner/:uuid/select-branch", element: <PartnerSelectBranch /> },
];
